import { FillLayer } from "react-map-gl";
import { Theme } from "@mui/material/styles";

export const getAreaBaseLayer = (gradient: string[]): FillLayer => {

  return {
    id: "area-base",
    type: "fill",
    "source-layer": "postal_area_test",
    maxzoom: 7,
    minzoom: 4,
    paint: {
      "fill-outline-color": "rgba(33,43,58,0.4)",
      "fill-color": [
        "case",
        ["==", ["feature-state", "score"], null],
        "#ECF3F4",
        [
          "interpolate",
          ["linear"],
          ["feature-state", "score"],
          0,
          gradient[0],
          0.1,
          gradient[1],
          0.2,
          gradient[2],
          0.3,
          gradient[3],
          0.4,
          gradient[4],
        ],
      ],
      "fill-opacity":
      [
        "case",
        ["==", ["feature-state", "score"], null],
        0,
        ["case", ["<", ["feature-state", "score"], 0], 0, 1],
      ],
    }
  }
}

export const getAreaOverlapLayer = (gradient: string[]): FillLayer => {

  return {
    id: "area-overlap",
    type: "fill",
    "source-layer": "postal_area_test",
    maxzoom: 7,
    minzoom: 4,
    paint: {
      "fill-outline-color": "rgba(33,43,58,0.4)",
      "fill-color": [
        "case",
        ["==", ["feature-state", "score"], null],
        "#ECF3F4",
        [
          "interpolate",
          ["linear"],
          ["feature-state", "score"],
          0,
          gradient[0],
          0.1,
          gradient[1],
          0.2,
          gradient[2],
          0.3,
          gradient[3],
          0.4,
          gradient[4],
        ],
      ],
      "fill-opacity":
        [
          "case",
          ["==", ["feature-state", "score"], null],
          0,
          ["case", ["<", ["feature-state", "score"], 0], 0, 1],
        ],
    }
  }
}
